import moment from 'moment';

export { moment };

export const momentFormats = {
    DATE: 'MM/DD/YYYY',
    DATE_TIME: 'MM/DD/YYYY  h:mm a',
    DATE_TEXT_AT_TIME: 'MMMM Do [at] h:mm a',
    LR_API_DATETIME: 'YYYY-MM-DD HH:mm:ssZ',
};
